module.exports = __webpack_public_path__ + "static/media/Gligar_gaussian2.d9ae51bc.png";